import SiteWrapper from "../../SiteWrapper.react";
import React from "react";
import '../../css/ProjectDetail.css';
import {useFormik} from "formik";
import {Container, Card, Box, TextField, FormControl, InputLabel, Button, Stack, Select, MenuItem, Grid} from "@mui/material";
import {TrueffortButton, TrueffortSelect, TrueffortTextField} from "../../MUIstyle/MUICustom";
import {Save as SaveIcon, Cancel as CancelIcon, Close as CloseIcon,} from '@mui/icons-material';
import ProjectElementService from "../../services/projectElement.service";
import {toast} from "react-toastify";
import { useState } from "react";
import SelectMulti from 'react-select';
import { dateToDateLocale } from "../../util/GlobalFunctions";
import DatePicker from "react-datepicker";
import { useMemo } from "react";
import TaskTypeService from "../../services/taskType.service";
import EstimationsService from "../../services/estimations.service";
import ProjectTaskService from "../../services/projectTask.service";
import ProjectPhaseService from "../../services/projectPhase.service";

// @ts-ignore
function AddTaskForm({users, t, formState, setFormState, project, _fillproject}) {
  const [idSelectedProjectElement, setIdSelectedProjectElement] = useState("");
  const [notSavedTasks, setNotSavedTasks] = useState([]);
  const [selectedNewTask, setSelectedNewTask] = useState({ id: 0, users: [] });
  const [valuesUsersSelect, setValuesUsersSelect] = useState([]);
  const [formikTask, setFormikTask] = useState({
    values: {
      idTaskType: 0, estimatedDays: 0, estimatedTime: 0,
      registredDate: dateToDateLocale(new Date())
    }, errors: { idTaskType: null }
  });
  const taskTypeService = useMemo(() => new TaskTypeService(), []);
  const estimationService = useMemo(() => new EstimationsService(), []);
  const projectTaskService = useMemo(() => new ProjectTaskService(), []);
  const projectPhaseService = useMemo(() => new ProjectPhaseService(), []);


  const fillNotSavedTasks = (idProjectElement: number) => {
    // @ts-ignore
    taskTypeService.getNotSavedTasks(idProjectElement).then(({ data: response }) => {
      if (Array.isArray(response.data) && response.data.length) {
        getTasksEstimate(response.data.map((task: any) => ({
          "id": task.idTaskType,
          "id_size": 2,
          "id_complexity": 2
        })));
      }
    });
  }

  const getTasksEstimate = (taskTypesIDs: any) => {
    // @ts-ignore
    estimationService.getAccumulatedEstimate({ "task_types": taskTypesIDs }).then(({ data: response }) => {
      if (response.status === "error") {
        toast.error(response.message);
      } else {
        const tasks = response.projecttypes[0].elementtypes[0].dificulties[0].phasetypes
          .map((phase: any) => {
            phase.tasktypes.forEach((task: any) => task.idPhaseType = phase.id);
            return phase.tasktypes;
          }).flat();
        setNotSavedTasks(tasks);
      }
    }).catch(function (error: any) {
      console.log(error);
      toast.error("Ocurrió un problema al ejecutar la estimación (" + error + ")");
    });
  }

  const handleTaskSelectChange = (idTaskType: number) => {
    const selectedTask = notSavedTasks.find((task: any) => task.id == idTaskType);
    setSelectedNewTask(selectedTask);
    setFormikTask({
      values: {
        ...formikTask.values, idTaskType: selectedTask.id, estimatedDays: Math.round(selectedTask.duration_avg),
        estimatedTime: Math.round(selectedTask.effort_avg)
      }, errors: formikTask.errors
    });
  }

  //console.log(dateToDateLocale(new Date()));
  //console.log(new Date());
  //console.log(formikTask);
  const handleSubmit = (values: any) => {
    let errors = validate(values);
    if (JSON.stringify(errors) != '{}') {
      //console.log(errors);
      setFormikTask({ values: formikTask.values, errors: errors });
      return;
    }
    const projectPhase = getProjectPhaseValue(values.idTaskType);
    const taskUsers = getArrUsersFromValues();

    if (projectPhase !== undefined) {
      const newProjectTask = {
        taskType: {
          idTaskType: values.idTaskType
        },
        projectPhase: {
          idProjectPhase: projectPhase.id
        },
        estimatedDays: values.estimatedDays,
        estimatedTime: values.estimatedTime,
        registredDate: values.registredDate,
        users: taskUsers
      }

      createProjectTask(newProjectTask);
    } else {
      const newProjectPhase = {
        projectElement: {
          idProjectElement: Number(idSelectedProjectElement)
        },
        idPhaseType: selectedNewTask.idPhaseType,
        estimatedDays: values.estimatedDays,
        estimatedTime: values.estimatedTime,
        projectTasks: [{
          taskType: {
            idTaskType: values.idTaskType
          },
          projectPhase: {
            idProjectPhase: 0
          },
          estimatedDays: values.estimatedDays,
          estimatedTime: values.estimatedTime,
          users: taskUsers
        }]
      }

      createProjectPhaseAndTask(newProjectPhase);
    }

    setIdSelectedProjectElement(0);

  }

  function getProjectPhaseValue(idTaskType: number) {
    let idPhaseType = notSavedTasks.find((task: any) => task.id == idTaskType).idPhaseType;
    const projectElement = project.elements.find((elem: any) => elem.id == idSelectedProjectElement);

    return projectElement.phases.find((phase: any) => phase.type_id == idPhaseType);
  }

  const validate = (values: any) => {
    let errors: any = {};
    if (!values.idTaskType) {
      errors.idTaskType = "Required";
    }

    if (new Date(values.registredDate) < new Date(project.registred_date)) {
      errors.registredDate = t("project_tasks_page.msg.errors.registred_date");
    }
    return errors;
  }

  function getArrUsersFromValues() {
    let arr: { idProjectTask: number; idUser: number; }[] = [];
    valuesUsersSelect.map((usr: any) => {
      arr.push({ idProjectTask: 0, idUser: usr.value });
    });

    return arr;
  }

  const createProjectTask = (newProjectTask: any) => {
    // @ts-ignore
    projectTaskService.create(newProjectTask).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
      } else {
        setFormState({ ...formState, showFormAddTask: false, isCreating: false });
        toast.success(t("project_page.msg_success_task_add"));
      }

      _fillproject();
    }).catch(function (error: any) {
      console.log(error);
      toast.error(t("project_tasks_page.msg_task_add_error"));
    });
  }

  const createProjectPhaseAndTask = (newProjectPhase: any) => {
    // @ts-ignore
    projectPhaseService.create(newProjectPhase).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
      } else {
        setFormState({ ...formState, showFormAddTask: false, isCreating: false });
        toast.success(t("project_page.msg_success_task_add"));
      }

      _fillproject();
    }).catch(function (error: any) {
      console.log(error);
      toast.error(t("project_tasks_page.msg_task_add_error"));
    });
  }

  const handleCancel = () => {
    setIdSelectedProjectElement(0);
    setFormikTask({ values: { idTaskType: 0, estimatedDays: 0, estimatedTime: 0 }, errors: { idTaskType: null } });
    setFormState({ ...formState, isCreating: false, isEditing: false, showFormAddTask: false });
  }

  return (
    <Card sx={{padding: "12px", marginTop: "1rem", overflow: "unset", marginBottom: "1rem"}}>
      <h5 className="color-primary">{t("project_tasks_page.add_task_title")}</h5>
      <Grid container spacing={1} >
        <Grid item xs={12} sm={4}>
          <TrueffortSelect
            id="idSlNewTaskElementType"
            name="idElementType"
            size="small"
            fullWidth
            label={t("project_tasks_page.select_element")}
            value={idSelectedProjectElement}
            onChange={(e: any) => {
              setIdSelectedProjectElement(e.target.value)
              fillNotSavedTasks(parseInt(e.target.value));
            }}
          >
            <MenuItem key="-1" value="" disabled>{t("Select")}</MenuItem>
            {project.elements.map((projectElement: any) =>
              <MenuItem key={projectElement.id} value={projectElement.id}>{projectElement.name}</MenuItem>
            )}
          </TrueffortSelect>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TrueffortSelect
            id="idSlTaskType"
            name="idTaskType"
            label={t("project_tasks_page.select_task")}
            size="small"
            fullWidth
            onChange={(e: any) => {
              setFormikTask({ values: {} })
              handleTaskSelectChange(e.target.value)
            }}
            disabled={!notSavedTasks.length}
            value={formikTask.values.idTaskType}
            error={formikTask.errors?.idTaskType}
          >
            <MenuItem value={0} disabled >{notSavedTasks.length ? t("Select") :
              t("estimation_page.no_tasks")}</MenuItem>
            {notSavedTasks.map((task: any) =>
              <MenuItem key={task.id} value={task.id} >
                {task.name}
              </MenuItem>)}
          </TrueffortSelect>
          {formikTask.errors.idTaskType && <span style={{ color: 'red', fontSize: '0.75rem' }}>
            {t(formikTask.errors.idTaskType)}</span>}
        </Grid>
        <Grid item xs={12} sm={4}>
          <SelectMulti
            name="users"
            isMulti
            label={t("project_tasks_page.assign_users")}
            placeholder={t("project_page.users")}
            value={valuesUsersSelect}
            isDisabled={!formikTask.values.idTaskType}
            onChange={(option: any) => setValuesUsersSelect(option)}
            options={
              users.map((usr: any) => (
                {
                  value: usr.idUser,
                  label: usr.fullNameEmail
                }
              ))
            }
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            name="estimatedDays"
            label={t("project_tasks_page.estimated_duration")}
            type="number"
            min="1"
            size="small"
            fullWidth
            disabled={!formikTask.values.idTaskType}
            onChange={(ev: any) => setFormikTask({
              values: { ...formikTask.values, estimatedDays: ev.target.value },
              errors: formikTask.errors
            })}
            value={formikTask.values.estimatedDays}
            error={formikTask.errors?.estimatedDays && formikTask.touched?.estimatedDays ?
              t(formikTask.errors.estimatedDays) : null} >
          </TextField>
        </Grid>
        <Grid item xs={12} sm={4} >
          <TextField
            name="estimatedTime"
            label={t("project_tasks_page.estimated_effort")}
            type="number"
            min="1"
            size="small"
            fullWidth
            disabled={!formikTask.values.idTaskType}
            onChange={(ev: any) => setFormikTask({
              values: { ...formikTask.values, estimatedTime: ev.target.value },
              errors: formikTask.errors
            })}
            value={formikTask.values.estimatedTime}
            error={formikTask.errors?.estimatedTime && formikTask.touched?.estimatedTime ?
              t(formikTask.errors.estimatedTime) : null} >
          </TextField>
        </Grid>
        <Grid item xs={2}>
          <DatePicker
            style={{ width: '100%' }}
            dateFormat="yyyy/MM/dd"
            selected={formikTask?.values?.registredDate}
            onChange={(date: any) => setFormikTask({
              values: { ...formikTask.values, registredDate: dateToDateLocale(date) },
              errors: formikTask.errors
            })}
            customInput={<TrueffortTextField
              size="small"
              name="registredDate"
              inputProps={{ background: 'red' }}
              error={formikTask.errors.registredDate || ''}
            />}
          />
        </Grid>
        <Grid xs={12} sm={2}>
          <TrueffortButton color="primary" onClick={() => handleSubmit(formikTask.values)}>
            <SaveIcon />
          </TrueffortButton>
          <TrueffortButton color="gray" onClick={handleCancel} >
            <CloseIcon />
          </TrueffortButton>
        </Grid>
        {formikTask.errors.registredDate && <Grid item xs={12} style={{ color: 'red', fontSize: '0.75rem' }}>
          {formikTask.errors.registredDate + ' ' + project.registred_date}</Grid>}
      </Grid>
    </Card>
  );
}

export default AddTaskForm;